import React, { useState } from 'react';
import { useGetStoneQuery } from 'state';
import { Skeleton } from 'components/_shared/Skeleton';
import { Button } from 'components/_shared/Button';
import { formatShortDay } from '../../fields.utils';
import {
  Card,
  Frame,
  Tile,
  Photo,
  FrameNote,
  Row,
  Mono,
  Est,
  Vetted,
  Tick,
  Message
} from './StoneDetail.styles';

const passDay = pass => (pass ? formatShortDay(pass.observed_on) : '—');

export const StoneDetail = ({ stoneId }) => {
  const { currentData, isFetching, isError, refetch } = useGetStoneQuery(stoneId);
  const [failedImage, setFailedImage] = useState(null);

  if (isError) {
    return (
      <Card data-testid='stone-detail'>
        <Message>
          Could not load this stone.
          <Button onClick={refetch}>Retry</Button>
        </Message>
      </Card>
    );
  }
  if (!currentData || isFetching) {
    return <Skeleton height='260px' />;
  }

  const { stone } = currentData;
  const hasImage = stone.image_url && failedImage !== stone.image_url;

  return (
    <Card data-testid='stone-detail'>
      <Frame>
        {hasImage ? (
          <Tile>
            <Photo
              src={stone.image_url}
              alt='Stone'
              onError={() => setFailedImage(stone.image_url)}
            />
          </Tile>
        ) : (
          <FrameNote>No image for this stone</FrameNote>
        )}
      </Frame>
      <Row>
        <span>Size</span>
        <b>
          {stone.size_cm == null ? (
            '—'
          ) : (
            <>
              {stone.size_cm} cm across{' '}
              <Est>{stone.size_is_mocked ? 'mocked size' : 'estimated'}</Est>
            </>
          )}
        </b>
      </Row>
      <Row>
        <span>Position</span>
        <Mono>
          {stone.lat.toFixed(5)}, {stone.lon.toFixed(5)}
        </Mono>
      </Row>
      <Row>
        <span>First seen</span>
        <b>{passDay(stone.first_pass)}</b>
      </Row>
      <Row>
        <span>Last seen</span>
        <b>{passDay(stone.last_pass)}</b>
      </Row>
      <Vetted>
        <Tick>✓</Tick> Checked by SoilMate
      </Vetted>
    </Card>
  );
};
